export default "__VITE_ASSET__CPCVPQ$C__"